module.exports = __webpack_public_path__ + "img/logo.c54e97ff.png";